import { render, staticRenderFns } from "./ManagementSummary.vue?vue&type=template&id=5bcd778a&"
import script from "./ManagementSummary.vue?vue&type=script&lang=js&"
export * from "./ManagementSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports